module.exports = __webpack_public_path__ + "static/media/changelog.ca824a49.png";